import styled from 'styled-components';
import { DEVICE } from '@app/styles';

interface StyledDivProps {
  children?: React.ReactNode;
}

export const DesktopOnly = styled.div<StyledDivProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px;

  @media ${DEVICE.laptop} {
    display: none;
  }
`;

export const LaptopOnly = styled.div<StyledDivProps>`
  padding: 12px;
  display: none;

  @media ${DEVICE.laptop} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;
